import React from 'react';
import MarkdownPage from '../components/MarkdownPage';

export default function Terms() {
  return <MarkdownPage fetchPath="/assets/terms.md" pageTitle="Terms & Conditions" />;
}
